module.exports = __webpack_public_path__ + "static/media/AFib-Worksheet-es.9be9dcce.pdf";